import React from "react";
import $ from "jquery";
import {FillTableAction} from "../../../../../../api/omnimap/omnimapActions";
import {PatchMethod} from "../../../../../../api/omnimap/omnimapApi";
import {sleep} from "../../../../../common/common";
import * as Common from "../../../../../common/common";
import * as omnimap from "../../../../../../api/omnimap/omnimapActions";
import {FillTableCallBack} from "../../../../../catalog/tableContext/area/functions/callBackFunctions";

class BulkUpdateEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state= {
            alias: "",
        }
        window.$mm_schedule_bulkUpdateEditContext = this

        this.handleUpdate = async (item) => {
            const preModelPath = "/content/extrainformatie/";
            const prePathField = "field";
            const prePathId = "identification";
            const objPath = prePathField + (this.props.rowId + 1);
            const updateModel = {op: "replace", path: "", value:""};
            const addModel = {op: "add", path: "/content/extrainformatie", value: {}};
            // E.G. model {op: "replace", path: "/content/extrainformatie/tekst03w", value: "Teks03"}
            // [{"op":"add","path":"/content/extrainformatie","value":{"tekst05w":"Changed" }} ]

            const modalArr = [];
            // Check if item has the extra field

            /*updateModel.path = preModelPath + this.props.field_name;
            updateModel.value = this.state.alias;*/
            //addModel.path = preModelPath + this.props.field_name;
            addModel.value = {[this.props.field_name]: this.state.alias};
            modalArr.push(addModel);
            await PatchMethod(modalArr, item[prePathId], false).then(r => console.log(r)).catch((e)=>alert(33))

            return ""
        }

        this.handleSubmit = async () => {
            // Iterate all fields, if the field is selected one, handle update
            const tmpArr = [];

            $("tr.selected").each(function (e) {
                tmpArr.push($(this).attr("rowId"));
            })

            for (const item of window.$mm_schedule_Glist){
                for(const i of tmpArr){
                    if(item["identification"] === i){
                        await window.$mm_schedule_bulkUpdateEditContext.handleUpdate(item);
                    }
                }
            }
            $("#cover-spin").show(0);

            Common.sleep(500).then(() => {
                // Handle reload
                window.$mm_schedule_tableReload();

                // Handle close
                window.$mm_schedule_bulkUpdateDetailOnClose();
            });
        }
    }

    componentDidMount() {
        // Handle close on popup closes
        $(document)
            .unbind("mouseup")
            .mouseup(function (e) {
                if(
                    e.target.id !== "" && e.target.id !== "alias-input-id"
                ){
                    window.$mm_schedule_bulkUpdateDetailOnClose();
                }
            });
    }


    render() {
        return (
            <div style={{alignItems:"center",marginRight: '1.7rem'}}>
                <div className="col-lg-4f text-center" >

                    <div className="box-detail-active">
                        <div className="box-title-1-active">Field Name</div>
                        <div className="box-title-2-active">{this.props.alias}</div>
                    </div>

                    <div className="box-detail">
                        <div className="box-title-1">Waarde</div>
                        <div className="box-title-2">
                            <input
                                id="alias-input-id"
                                name="alias"
                                align="center"
                                width={3}
                                value={this.state.alias}
                                onChange={event => this.setState({alias: event.target.value})}
                            />
                        </div>
                    </div>

                    <div/>
                    <div style={{alignItems:"center",marginTop: '1.7rem'}}>
                        <a className="button ok" onClick={this.handleSubmit}>Opslaan</a>
                    </div>

                </div>
            </div>
        )
    }
}

export default BulkUpdateEdit;